'use client';

import { useState, type ReactElement } from 'react';
import { TbCheck } from 'react-icons/tb';

import { submitWidgetFeedback } from './actions';

import { RatingInteraction } from '@/app/(app)/suporte/_components/rating-interaction';

export function FeedbackBlock(): ReactElement {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (sent) {
    return (
      <div className="border-border-subtle/60 bg-surface-elevated/40 rounded-2xl border p-4 text-center">
        <TbCheck size={26} className="text-success mx-auto" strokeWidth={2.4} />
        <p className="text-ink mt-1 text-sm font-semibold">Feedback enviado!</p>
        <p className="text-ink-muted text-xs">Valeu. Isso ajuda demais a melhorar o Trakd.</p>
      </div>
    );
  }

  return (
    <div className="border-border-subtle/60 bg-surface-elevated/40 rounded-2xl border p-4">
      <p className="text-ink mb-3 text-center text-sm font-semibold">Como foi sua experiencia?</p>
      <RatingInteraction onChange={setRating} />
      {rating > 0 && (
        <div className="mt-3">
          <label className="text-ink-muted mb-1 block text-[11px]">
            Quer contar mais? (opcional)
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={2}
            maxLength={2000}
            placeholder="O que voce achou..."
            className="border-border-subtle/60 bg-bg text-ink w-full resize-none rounded-lg border px-3 py-2 text-xs focus:outline-none"
          />
          <button
            type="button"
            disabled={busy}
            onClick={() => {
              setBusy(true);
              void submitWidgetFeedback({ rating, comment, source: 'chatwidget' }).then((r) => {
                if (r.ok) setSent(true);
                setBusy(false);
              });
            }}
            className="bg-trakd-fill text-on-brand mt-2 w-full rounded-lg py-2 text-xs font-semibold disabled:opacity-50"
          >
            Enviar feedback
          </button>
        </div>
      )}
    </div>
  );
}
